// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__11wK2","label":"Section_label__57bYE","contentWrap":"Section_contentWrap__1LkGx","footer":"Section_footer__1ayIr","footerInner":"Section_footerInner__WoB-X"};